// src/CreditsBadge.js
import React, { useEffect, useState } from "react";
import { fetchEntitlements } from "./paymentsClient";
import { tUI } from "./i18n";

export default function CreditsBadge({ language }) {
  const [ent, setEnt] = useState(null);

  async function refresh() {
    try { setEnt(await fetchEntitlements()); } catch {}
  }

  useEffect(() => {
    refresh();
    const h = () => refresh();
    window.addEventListener("refresh-entitlements", h);
    return () => window.removeEventListener("refresh-entitlements", h);
  }, []);

  // If no active plan → DO NOT show anything
  if (!ent || ent.status !== "active") return null;

  const used = ent.quota_used_month ?? 0;
  const total = ent.quota_monthly ?? 0;
  const left  = total - used;

  // 👇 NEW LOGIC: Only show when no credits left
  if (left > 0) return null;

  // Message is ALWAYS "no credits left"
  const message = tUI(language, "credits_none");

  return (
    <span
      style={{
        padding: "6px 10px",
        borderRadius: 8,
        background: "#ffeef0",
        border: "1px solid #ffb6b6",
        fontSize: 12,
        display: "inline-block",
        marginBottom: 8,
        color: "#b10000",
        fontWeight: 500,
      }}
    >
      {message}
    </span>
  );
}
